// Canvas-only spotlight guidance; advancement follows real actions, not a timer.
export default class Tutorial {
  constructor(game){this.game=game;this.step=0;this.region=null}
  allows(x,y){return this.region&&x>=this.region.x&&x<=this.region.x+this.region.w&&y>=this.region.y&&y<=this.region.y+this.region.h}
  worldRegion(x,y,w=1,h=1){const g=this.game,z=g.cam.z;return {x:(x*56-g.cam.x)*z+g.w/2,y:(y*56-g.cam.y)*z+g.h/2,w:w*56*z,h:h*56*z}}
  draw(){
    const g=this.game,c=g.c
    if(this.step===6&&[-3,-2].every(x=>{const b=g.map.get(x+',0');return b&&b.type==='belt'&&b.dir===0}))this.step=7
    if(this.step===7&&g.levelComplete)this.step=8
    let target=null
    if(this.step===1)target=g.buttons.find(b=>b.tab===0&&b.tooltip==='JavaScript 标准库')
    if(this.step===2)target=g.buttons.find(b=>b.tab===1&&b.tooltip==='JavaScript 字面量')
    if(this.step===3)target=g.buttons.find(b=>b.tab===3&&b.tooltip==='String 字面量')
    if(this.step===5)target=g.buttons.find(b=>b.tutorialId==='belt')
    this.region=target?{x:target.x,y:target.y,w:target.w,h:target.h}:this.step===4?g.editorBounds:this.step===3.5?this.worldRegion(-4,0):this.step===6?this.worldRegion(-3,0,2,1):this.step===7?this.worldRegion(-1,-1,3,3):null
    if(target){const action=target.fn;target.fn=()=>{action();this.step=this.step===1?3:this.step===3?3.5:this.step+1}}
    const r=this.region
    c.save();c.fillStyle='#1c2c25a8'
    if(r){
      c.fillRect(0,0,g.w,Math.max(0,r.y-5));c.fillRect(0,r.y+r.h+5,g.w,g.h-r.y-r.h-5)
      c.fillRect(0,r.y-5,Math.max(0,r.x-5),r.h+10);c.fillRect(r.x+r.w+5,r.y-5,g.w-r.x-r.w-5,r.h+10)
      c.shadowColor='#ffb53d77';c.shadowBlur=14;g.rect(r.x-4,r.y-4,r.w+8,r.h+8,null,8,'#ffb53d');c.shadowBlur=0
    }else c.fillRect(0,0,g.w,g.h)
    const copy={
      0:['第一单，送出一声问候','我们从空工厂开始。写下 ok，让它沿传送带进入中央出货站。'],
      1:['走进基础工坊','点击高亮的基础工坊。'],2:['找到原材料','点击高亮的原材料车间。'],
      3:['选择文字物料','点击传送带右侧的文字按钮，带上一份文字物料。'],3.5:['放下文字物料','点击高亮的格子，在出货站左侧放一份文字物料。'],
      4:['写下第一句问候','在多行输入框中填写 ok，再点击“确认文字”。'],
      5:['准备传送带','点击高亮的传送带按钮。'],6:['连通出货站','从高亮区域左侧向右拖动，铺满这两个格子。'],
      7:['看它进入出货站','等待文字沿传送带进入中央出货站，完成本次交付。'],
      8:['第一单，完成了！','你送出了 ok。生产总单中的主流程，也交出了同样的内容。']
    }[this.step]||['继续生产','按提示完成当前操作。']
    if(this.step===4&&g.h<600){
      g.text('填写 ok，再确认文字',g.w/2,12,10,'#f6f8f0','center')
      c.restore();return
    }
    const width=Math.min(360,g.w-24),height=this.step===0||this.step===8?192:130
    let y=this.step===0||this.step===8?(g.h-height)/2:r&&r.y>g.h/2?Math.max(12,r.y-height-18):Math.min(g.h-height-12,Math.max(12,r?r.y+r.h+18:100))
    if(this.step===4)y=g.h-height-12
    const x=(g.w-width)/2
    g.rect(x,y,width,height,'#fbfcf5',14,'#d3dfc8');g.text('入门教程  ·  '+(this.step===8?'已完成':Math.min(7,Math.ceil(this.step))+' / 7'),x+18,y+20,10,'#99a68c')
    g.text(copy[0],x+18,y+46,18,'#48613c','left',700);g.wrap(copy[1],x+18,y+76,width-36,12,3)
    if(this.step===0||this.step===8)g.button(x+18,y+height-48,width-36,32,this.step===0?'开始第一单':'开始正式订单',()=>{if(this.step===0){g.workshop=0;g.category=0;g.tabOffsets=[0,0,0,0];g.cam={x:-56,y:0,z:g.small?0.65:0.85};this.step=1}else g.startMission(0)},true)
    if(this.step===0||this.step===8)g.buttons[g.buttons.length-1].tutorialControl=true
    g.text('跳过教程',g.w-18,18,11,'#edf3e4','right')
    g.buttons.push({x:g.w-100,y:3,w:94,h:28,tutorialControl:true,fn:()=>{g.startMission(0)}})
    c.restore()
  }
}
